// Story 8.3 (ADO-2012), Tasks 11.3 and 11.8: the Conflict Message a product surface (the
// product card, the PDP hero, the search typeahead row) shows for its product: the store's
// recorded conflict as the designer's copy, with the action, if any. `null` when there is
// none to show, and on a blocked surface (one that offers no Add or stepper), which shows no
// basket message either. Each surface runs the action with its own focus hand-off.

import { conflictView, type ConflictViewAction } from './conflictCopy';
import { useBasketStore } from './useBasketStore';

export interface LineConflictMessage {
  readonly message: string;
  readonly action: ConflictViewAction | null;
}

export function useLineConflictMessage(
  skuCode: string,
  { blocked }: { readonly blocked: boolean },
): LineConflictMessage | null {
  const lineConflict = useBasketStore((s) => s.lineConflicts.get(skuCode));
  if (lineConflict === undefined || blocked) return null;
  const view = conflictView(lineConflict);
  return view.kind === 'none' ? null : { message: view.message, action: view.action };
}
